module.exports = __webpack_public_path__ + "img/phone.6af47a1b.png";